






























































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { agentsAdminModule } from "@/store/modules/agents-admin-module";
import {
  AgentDto,
  LicenseDto,
  ConnectionDto,
  HeartbeatDto,
  CommandDto,
  CommandResultDto,
  AuditEventDto,
  ReleaseDto,
  UpdateJobDto,
  SqlQueryRequestDto,
  SqlQueryResponseDto,
  AgentsOverviewResponse,
} from "@/shared/dtos/agents-admin";

import OverviewTab from "@/components/agents-admin/tabs/OverviewTab.vue";
import AgentsTab from "@/components/agents-admin/tabs/AgentsTab.vue";
import LicensesTab from "@/components/agents-admin/tabs/LicensesTab.vue";
import ConnectionsTab from "@/components/agents-admin/tabs/ConnectionsTab.vue";
import HeartbeatsTab from "@/components/agents-admin/tabs/HeartbeatsTab.vue";
import CommandsTab from "@/components/agents-admin/tabs/CommandsTab.vue";
import AuditEventsTab from "@/components/agents-admin/tabs/AuditEventsTab.vue";
import ReleasesTab from "@/components/agents-admin/tabs/ReleasesTab.vue";
import UpdateJobsTab from "@/components/agents-admin/tabs/UpdateJobsTab.vue";
import SqlQueryTab from "@/components/agents-admin/tabs/SqlQueryTab.vue";
import DiagnosticTab from "@/components/agents-admin/tabs/DiagnosticTab.vue";

@Component({
  components: {
    OverviewTab,
    DiagnosticTab,
    AgentsTab,
    LicensesTab,
    ConnectionsTab,
    HeartbeatsTab,
    CommandsTab,
    AuditEventsTab,
    ReleasesTab,
    UpdateJobsTab,
    SqlQueryTab,
  },
})
export default class AgentsAdmin extends Vue {
  public activeTab: number = 0;
  public selectedAgentId: string = "";
  private loadedTabs: { [key: number]: boolean } = {};

  public get loading(): boolean {
    return agentsAdminModule.loading;
  }

  public get error(): string {
    return agentsAdminModule.error;
  }

  public get overview(): AgentsOverviewResponse {
    return agentsAdminModule.overview;
  }

  public get agents(): AgentDto[] {
    return agentsAdminModule.agents;
  }

  public get licenses(): LicenseDto[] {
    return agentsAdminModule.licenses;
  }

  public get connections(): ConnectionDto[] {
    return agentsAdminModule.connections;
  }

  public get heartbeats(): HeartbeatDto[] {
    return agentsAdminModule.heartbeats;
  }

  public get commands(): CommandDto[] {
    return agentsAdminModule.commands;
  }

  public get commandResults(): CommandResultDto[] {
    return agentsAdminModule.commandResults;
  }

  public get auditEvents(): AuditEventDto[] {
    return agentsAdminModule.auditEvents;
  }

  public get releases(): ReleaseDto[] {
    return agentsAdminModule.releases;
  }

  public get updateJobs(): UpdateJobDto[] {
    return agentsAdminModule.updateJobs;
  }

  public get sqlQueryResult(): SqlQueryResponseDto {
    return agentsAdminModule.sqlQueryResult;
  }

  public get sqlQueryHistory(): SqlQueryRequestDto[] {
    return agentsAdminModule.sqlQueryHistory;
  }

  public get agentFilterItems(): Array<{ text: string; value: string }> {
    const set: { [key: string]: boolean } = {};

    this.agents.forEach((x) => {
      if (x.agent_id) set[x.agent_id] = true;
    });
    this.licenses.forEach((x) => {
      if (x.agent_id) set[x.agent_id] = true;
    });
    this.connections.forEach((x) => {
      if (x.agent_id) set[x.agent_id] = true;
    });
    this.heartbeats.forEach((x) => {
      if (x.agent_id) set[x.agent_id] = true;
    });
    this.commands.forEach((x) => {
      if (x.agent_id) set[x.agent_id] = true;
    });
    this.auditEvents.forEach((x) => {
      if (x.agent_id) set[x.agent_id] = true;
    });
    this.updateJobs.forEach((x) => {
      if (x.agent_id) set[x.agent_id] = true;
    });

    const items = Object.keys(set)
      .sort()
      .map((id) => ({ text: id, value: id }));
    return [{ text: "Todos", value: "" }].concat(items);
  }

  public get filteredAgents(): AgentDto[] {
    if (!this.selectedAgentId) return this.agents;
    return this.agents.filter((x) => x.agent_id === this.selectedAgentId);
  }

  public get filteredLicenses(): LicenseDto[] {
    if (!this.selectedAgentId) return this.licenses;
    return this.licenses.filter((x) => x.agent_id === this.selectedAgentId);
  }

  public get filteredConnections(): ConnectionDto[] {
    if (!this.selectedAgentId) return this.connections;
    return this.connections.filter((x) => x.agent_id === this.selectedAgentId);
  }

  public get filteredHeartbeats(): HeartbeatDto[] {
    if (!this.selectedAgentId) return this.heartbeats;
    return this.heartbeats.filter((x) => x.agent_id === this.selectedAgentId);
  }

  public get filteredCommands(): CommandDto[] {
    if (!this.selectedAgentId) return this.commands;
    return this.commands.filter((x) => x.agent_id === this.selectedAgentId);
  }

  public get filteredAuditEvents(): AuditEventDto[] {
    if (!this.selectedAgentId) return this.auditEvents;
    return this.auditEvents.filter((x) => x.agent_id === this.selectedAgentId);
  }

  public get filteredUpdateJobs(): UpdateJobDto[] {
    if (!this.selectedAgentId) return this.updateJobs;
    return this.updateJobs.filter((x) => x.agent_id === this.selectedAgentId);
  }

  public get filteredCommandResults(): CommandResultDto[] {
    if (!this.selectedAgentId) return this.commandResults;

    const commandAgentById: { [key: string]: string } = {};
    this.commands.forEach((cmd) => {
      commandAgentById[cmd.command_id] = cmd.agent_id;
    });

    return this.commandResults.filter((result) => {
      if (result.agent_id && result.agent_id === this.selectedAgentId) {
        return true;
      }

      const mappedAgent = commandAgentById[result.command_id];
      return mappedAgent === this.selectedAgentId;
    });
  }

  public get filteredOverview(): AgentsOverviewResponse {
    const base: any = this.overview || {};
    const allAgents = Array.isArray(base.agents) ? base.agents : [];
    const filteredAgents = this.selectedAgentId
      ? allAgents.filter((a: any) => a.agent_id === this.selectedAgentId)
      : allAgents;

    const summary = Object.assign({}, base.summary || {});
    summary.total_agents = filteredAgents.length;
    summary.online_agents = filteredAgents.filter(
      (a: any) => a.is_online
    ).length;
    summary.offline_agents = filteredAgents.length - summary.online_agents;
    summary.total_commands_executed = this.filteredCommands.length;

    return Object.assign({}, base, {
      agents: filteredAgents,
      summary,
    }) as AgentsOverviewResponse;
  }

  public async mounted() {
    await this.loadAll();
    this.loadedTabs[0] = true;
  }

  @Watch("activeTab")
  public async onActiveTabChanged(tabIndex: number) {
    if (this.loadedTabs[tabIndex]) return;
    await this.loadTabData(tabIndex);
    this.loadedTabs[tabIndex] = true;
  }

  public async loadAll() {
    try {
      // First load overview (contains all datasets) to paint tabs immediately.
      await agentsAdminModule.getOverview({});

      // Then refresh each dataset in background without breaking whole load if one fails.
      await Promise.allSettled([
        agentsAdminModule.getAgents({}),
        agentsAdminModule.getLicenses({}),
        agentsAdminModule.getConnections({}),
        agentsAdminModule.getHeartbeats({}),
        agentsAdminModule.getCommands({}),
        agentsAdminModule.getCommandResults({}),
        agentsAdminModule.getAuditEvents({}),
        agentsAdminModule.getReleases({}),
        agentsAdminModule.getUpdateJobs({}),
      ]);
    } catch (error) {
      console.error("Error loading agents admin data:", error);
    }
  }

  public async refreshAll() {
    this.loadedTabs = {};
    await this.loadAll();
    this.loadedTabs[0] = true;
  }

  public async loadAgents() {
    await agentsAdminModule.getAgents({});
  }

  public async loadLicenses() {
    await agentsAdminModule.getLicenses({});
  }

  public async loadConnections() {
    await agentsAdminModule.getConnections({});
  }

  public async loadHeartbeats() {
    await agentsAdminModule.getHeartbeats({});
  }

  public async loadCommands() {
    await agentsAdminModule.getCommands({});
  }

  public async loadCommandResults() {
    await agentsAdminModule.getCommandResults({});
  }

  public async loadAuditEvents() {
    await agentsAdminModule.getAuditEvents({});
  }

  public async loadReleases() {
    await agentsAdminModule.getReleases({});
  }

  public async loadUpdateJobs() {
    await agentsAdminModule.getUpdateJobs({});
  }

  public async executeSqlQuery(request: SqlQueryRequestDto) {
    try {
      await agentsAdminModule.executeSqlQuery(request);
    } catch (error) {
      console.error("Error executing SQL query:", error);
    }
  }

  public clearError() {
    agentsAdminModule.setError("");
  }

  private async loadTabData(tabIndex: number) {
    try {
      switch (tabIndex) {
        case 1: // Diagnóstico — getAgentState se dispara desde DiagnosticTab via @Watch
          break;
        case 2:
          await this.loadAgents();
          break;
        case 3:
          await this.loadLicenses();
          break;
        case 4:
          await this.loadConnections();
          break;
        case 5:
          await this.loadHeartbeats();
          break;
        case 6:
          await this.loadCommands();
          await this.loadCommandResults();
          break;
        case 7:
          await this.loadAuditEvents();
          break;
        case 8:
          await this.loadReleases();
          break;
        case 9:
          await this.loadUpdateJobs();
          break;
        case 10:
          await this.loadAgents();
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Error loading tab data:", error);
    }
  }
}
